import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormulaEvaluatorComponent } from './formula-evaluator/formula-evaluator.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    FormulaEvaluatorComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class OfferFormulaEvaluatorModule { }
